import { Setting, SettingKey } from '@favid-inc/api';
import React from 'react';
import { Loading } from 'utils';

import { SettingsContext } from './context';
import { fetchSettings } from './service';
import { SettingForm } from './SettingForm';

export const SettingsPage: React.FunctionComponent = () => {
  const [settings, setSettings] = React.useState<Setting[]>([]);
  const [fetching, setFetching] = React.useState<boolean>(true);

  React.useEffect(() => {
    setFetching(true);
    fetchSettings()
      .then(({ data: { list } }) => setSettings(list))
      .catch(() => alert('erro ao buscar configurações'))
      .then(() => setFetching(false));
  }, [setFetching]);

  if (fetching) {
    return <Loading />;
  }

  return (
    <div className='ui segment'>
      <SettingsContext.Provider value={settings}>
        <SettingForm
          label='Valor Mínimo Artista'
          settingKey={SettingKey.ARTIST_MINIMUM_PRICE}
          type='number'
        />
      </SettingsContext.Provider>
    </div>
  );
};
